import type { Email } from "../../../utils/interfaces";
import type { ReplyMode } from "../../../utils/replyRecipients";
import { EmailAttachmentList } from "./EmailAttachmentList";
import { EmailMessageBody } from "../../emails/EmailMessageBody";

export function EmailMessageBubble({
  email,
  isOutgoing,
  onReply,
  highlighted = false,
}: {
  email: Email;
  isOutgoing: boolean;
  onReply?: (message: Email, mode: ReplyMode) => void;
  highlighted?: boolean;
}) {
  const toDisplay = Array.isArray(email.to_email)
    ? email.to_email.join(", ")
    : email.to_email;

  return (
    <article
      id={
        email.gmail_message_id
          ? `message-${email.gmail_message_id}`
          : undefined
      }
      className={`flex ${isOutgoing ? "justify-end" : "justify-start"}`}
    >
      <div
        className={`w-full max-w-[92%] rounded-lg border p-4 shadow-sm sm:max-w-[85%] ${
          highlighted
            ? "border-amber-300 bg-amber-50 ring-2 ring-amber-200"
            : isOutgoing
              ? "border-teal-200 bg-teal-50/80"
              : "border-slate-200 bg-white"
        }`}
      >
        <div className="mb-2 flex flex-wrap items-center justify-between gap-2">
          <div className="flex flex-wrap items-center gap-2 text-xs">
            <span
              className={`rounded-full px-2 py-0.5 font-medium ${
                isOutgoing
                  ? "bg-teal-100 text-teal-800"
                  : "bg-slate-100 text-slate-700"
              }`}
            >
              {isOutgoing ? "Sent" : "Received"}
            </span>
            <span className="font-medium text-slate-700">
              {email.from_email}
            </span>
            <span className="text-slate-400">→</span>
            <span className="text-slate-600">{toDisplay}</span>
            <span className="text-slate-400">·</span>
            <span className="text-slate-500">{email.when}</span>
          </div>
          {!isOutgoing && onReply && email.gmail_message_id ? (
            <div className="flex gap-1">
              <button
                type="button"
                onClick={() => onReply(email, "reply")}
                className="rounded-md border border-slate-200 bg-white px-2 py-1 text-xs font-medium text-slate-700 hover:bg-slate-50"
              >
                Reply
              </button>
              <button
                type="button"
                onClick={() => onReply(email, "reply_all")}
                className="rounded-md border border-slate-200 bg-white px-2 py-1 text-xs font-medium text-slate-700 hover:bg-slate-50"
              >
                Reply all
              </button>
            </div>
          ) : null}
        </div>
        <EmailMessageBody content={email.content} />
        {email.gmail_message_id ? (
          <EmailAttachmentList
            messageId={email.gmail_message_id}
            attachments={email.attachments}
          />
        ) : null}
      </div>
    </article>
  );
}
